import { ItemGroup } from '@/experiences/sales-portal/domain/order-guides/blocs/transformers/group-by-item';
import { OrderGuideItem } from '@/experiences/sales-portal/domain/order-guides/blocs/types';

/**
 * Filters item groups by a search term, matching case-insensitively on item
 * name, pack size text (`packDisplayString`, e.g. "25 lb"), or pack external
 * ID (SKU). A match returns the whole group with all variants.
 */
export const filterItemGroups = (
  itemGroups: ItemGroup<OrderGuideItem>[],
  searchTerm: string,
): ItemGroup<OrderGuideItem>[] => {
  const normalized = searchTerm.trim().toLowerCase();
  if (normalized.length === 0) {
    return itemGroups;
  }

  return itemGroups.filter((group) =>
    group.items.some(
      (item) =>
        item.displayName.toLowerCase().includes(normalized) ||
        item.packDisplayString.toLowerCase().includes(normalized) ||
        (item.externalID?.toLowerCase().includes(normalized) ?? false),
    ),
  );
};
